/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Household(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.69238 2.38068C9.92554 2.30539 10.1801 2.31729 10.4062 2.41779L17.9062 5.75178C18.2669 5.91234 18.4998 6.27006 18.5 6.66486V17.4988C18.4998 18.0508 18.052 18.4986 17.5 18.4988C16.9478 18.4988 16.5002 18.051 16.5 17.4988V7.31428L10 4.4256L3.5 7.31428V17.4988C3.49982 18.0508 3.05197 18.4986 2.5 18.4988C1.94782 18.4988 1.50018 18.051 1.5 17.4988V6.66486C1.50018 6.26994 1.7329 5.91227 2.09375 5.75178L9.59375 2.41779L9.69238 2.38068ZM10 8.16486C10.4859 8.16498 10.9522 8.35847 11.2959 8.70197C11.6001 9.00623 11.7864 9.40687 11.8252 9.83185H14.167C14.7189 9.83228 15.1669 10.2799 15.167 10.8319V17.4988C15.1668 18.0507 14.7188 18.4984 14.167 18.4988H5.83301C5.28098 18.4987 4.83318 18.0509 4.83301 17.4988V12.4988C4.83308 11.9467 5.28092 11.499 5.83301 11.4988H6.5V9.99885C6.50004 9.51267 6.69333 9.04576 7.03711 8.70197L7.17188 8.5799C7.49789 8.3131 7.90803 8.16494 8.33301 8.16486H10ZM6.83301 16.4988H9.83301V13.4988H6.83301V16.4988ZM11.833 16.4988H13.167V11.8319H11.833V16.4988ZM8.5 11.4988H9.83301V10.1649H8.5V11.4988Z"
        fill="#35424F"
      />
    </svg>
  )
}

Household.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Household
